export default __webpack_public_path__ + "static/media/bear_pic_6_mobile.6542a2ee.png";